export default {
  header: {
    signIn: 'سائن ان',
    signUp: 'سائن اپ'
  },
  userMenu: {
    wallet: 'بٹوہ',
    withdraw: 'رقم نکالیں',
    transaction: 'لین دین',
    myBet: 'میری شرط',
    rollover: 'رول اوور',
    vault: 'تجوری',
    profile: 'پروفائل',
    settings: 'ترتیبات',
    signOut: 'سائن آؤٹ',
    signOutTitle: 'سائن آؤٹ',
    signOutContent: 'انعامات اور دلچسپ گیمز سے بھری دنیا کو دریافت کریں!',
    signOutConfirm: 'سائن آؤٹ',
    cancel: 'منسوخ کریں'
  }
};
